// Single delegated listener — survives all DOM replacements
document.addEventListener('click', async (e) => {
  const button = e.target.closest('.load-more-button');
  if (!button || button.disabled) return;

  const url = button.getAttribute('data-next-url');
  if (!url) return;

  const originalText = button.textContent;
  button.textContent = 'Loading...';
  button.disabled = true;

  try {
    const response = await fetch(url);
    const text = await response.text();
    const html = new DOMParser().parseFromString(text, 'text/html');

    const newGrid = html.querySelector('[data-product-grid]');
    const grid = document.querySelector('[data-product-grid]');

    if (newGrid && grid) {
      Array.from(newGrid.children).forEach((item) => grid.appendChild(item));
    }

    const newButton = html.querySelector('.load-more-button');
    if (newButton?.getAttribute('data-next-url')) {
      button.setAttribute('data-next-url', newButton.getAttribute('data-next-url'));
      button.textContent = originalText;
      button.disabled = false;
    } else {
      button.closest('[data-load-more-container]')?.remove();
    }

  } catch (err) {
    console.error('LoadMore error:', err);
    button.textContent = 'Error — try again';
    button.disabled = false;
  }
});